import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppSelector } from '../redux/store';
import { selectIsCorporateParent, selectCustomer } from '../redux/customer';
import { selectIsAdminOrOwner, selectCurrentUser } from '../redux/user';
import { useSessionLoading } from '../contexts/SessionLoadingContext';

const CorporateRouteGuard = ({ children }) => {
  const navigate = useNavigate();
  const { isSessionLoading } = useSessionLoading();

  const isCorporateParent = useAppSelector(selectIsCorporateParent);
  const isAdminOrOwner = useAppSelector(selectIsAdminOrOwner);
  const customer = useAppSelector(selectCustomer);
  const currentUser = useAppSelector(selectCurrentUser);

  const isDataLoaded = customer && currentUser &&
    customer.customer_number &&
    currentUser.access_level !== undefined;

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!isDataLoaded && !isSessionLoading) {
        console.error('CorporateRouteGuard timed out waiting for data');
        navigate('/practice/dashboard');
      }
    }, 10000);

    if (isDataLoaded) {
      if (!isAdminOrOwner || !isCorporateParent) {
        console.error('User is not admin or owner');
        navigate('/practice/dashboard');
        return;
      }

      if (isCorporateParent && isAdminOrOwner) {
        return;
      }
    }

    return () => clearTimeout(timeoutId);
  }, [isCorporateParent, isAdminOrOwner, isDataLoaded, navigate, isSessionLoading]);

  return children;
};

export default CorporateRouteGuard;
